import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/CloseButton.css';

interface CloseButtonProps {
  onClose?: () => void;
  returnTo?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClose, returnTo }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClose) {
      onClose();
    } else if (returnTo) {
      navigate(returnTo);
    }
  };

  return (
    <div className="close-button-container">
      <button className="close-button" onClick={handleClick}>
        <span className="close-icon">&times;</span>
      </button>
    </div>
  );
};

export default CloseButton;
